import { IconPropsType } from '..';

export const CasinoColoredIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.86198 12.2996C4.69291 12.2017 4.57278 12.046 4.51939 11.8591C4.466 11.6723 4.4927 11.4721 4.59058 11.3075L8.59043 4.31772L8.31457 3.57026C8.24784 3.38784 8.10991 3.24102 7.93639 3.16094C7.76287 3.08085 7.55821 3.07196 7.38024 3.1387L1.47613 5.33216C1.29371 5.3989 1.14689 5.53681 1.0668 5.71033C0.986715 5.88385 0.977816 6.08851 1.04455 6.26648L4.14121 14.6088C4.20795 14.7912 4.34587 14.938 4.51939 15.0181C4.69291 15.0982 4.89758 15.1071 5.07554 15.0403L7.84741 14.0126L4.85308 12.2996H4.86198Z"
        fill="currentColor"
      />
      <path
        d="M16.6479 6.13309L11.2421 2.90296C11.0775 2.80508 10.8773 2.77394 10.6904 2.82288C10.5036 2.87182 10.3434 2.99195 10.2411 3.15657L5.67616 10.7959C5.57828 10.9605 5.54714 11.1607 5.59608 11.3476C5.64502 11.5345 5.76515 11.6946 5.92977 11.7969L11.3311 15.0271C11.4957 15.125 11.696 15.1561 11.8828 15.1072C12.0697 15.0582 12.2299 14.9381 12.3322 14.7735L16.8971 7.13417C16.995 6.96955 17.0261 6.76934 16.9772 6.58247C16.9282 6.3956 16.8081 6.23543 16.6435 6.13309H16.6479ZM12.7237 10.6357C12.0341 11.1696 11.1354 10.6579 11.0197 9.91493C11.0197 9.91493 10.3122 11.2185 10.9262 11.8058L9.01752 10.6402C9.82283 10.9205 10.6593 9.69247 10.6593 9.69247C9.94741 9.92828 9.07981 9.36324 9.23999 8.50899C9.40016 7.66809 9.96521 7.54796 10.7705 7.50791C11.3133 7.48122 12.5769 6.96955 12.5769 6.96955C12.5769 6.96955 12.697 8.32658 12.9195 8.82044C13.2487 9.55456 13.4 10.1107 12.7237 10.6402V10.6357Z"
        fill="#F0F0F0"
      />
    </svg>
  );
};
